import moment from "moment-timezone";
import { globals, page as pageIndex } from "../../globals";
import { logOut } from "./auth";
import { formatDate } from "./formatDate";
import {
  GET_CLIENTS_FAILURE,
  GET_CLIENT_SUBJECT_INFO_FAILURE,
  GET_GROUPING_FAILURE,
  GET_SUBJECTS_FAILURE,
  POST_CLIENT_SUBJECT_TAG_FAILURE,
  POST_CLIENT_SUBJECT_TAG_SUCCESS
} from "./groupings";
import { populateSortAndSearchParams } from "./helpers";
import { showModal } from "./modal";
import { clearHistory, saveInitialValues } from "./undo";
import { UPDATE_DATA, actionHandler } from "./updateData";

// ------------------------------------
// Constants
// ------------------------------------
export const STATUS_REVIEW_OPEN_RECORD_START =
  "STATUS_REVIEW_OPEN_RECORD_START";
export const GET_STATUS_REVIEW_QUERIES_LIST_START =
  "GET_STATUS_REVIEW_QUERIES_LIST_START";
export const GET_STATUS_REVIEW_QUERY_DATA_START =
  "GET_STATUS_REVIEW_QUERY_DATA_START";
export const GET_STATUS_REVIEW_QUERY_DATA_SUCCESS =
  "GET_STATUS_REVIEW_QUERY_DATA_SUCCESS";
export const GET_STATUS_REVIEW_QUERY_DATA_FAILURE =
  "GET_STATUS_REVIEW_QUERY_DATA_FAILURE";
export const SET_LEGIS_TRACK_TEAMS_REVIEW_DATA_START =
  "SET_LEGIS_TRACK_TEAMS_REVIEW_DATA_START";
export const SET_LEGIS_TRACK_TEAMS_REVIEW_DATA_SUCCESS =
  "SET_LEGIS_TRACK_TEAMS_REVIEW_DATA_SUCCESS";
export const SET_LEGIS_TRACK_TEAMS_REVIEW_DATA_FAILURE =
  "SET_LEGIS_TRACK_TEAMS_REVIEW_DATA_FAILURE";
export const POST_LEGIS_TRACK_DATA_START = "POST_LEGIS_TRACK_DATA_START";
export const POST_LEGIS_TRACK_DATA_SUCCESS = "POST_LEGIS_TRACK_DATA_SUCCESS";
export const POST_LEGIS_TRACK_DATA_FAILURE = "POST_LEGIS_TRACK_DATA_FAILURE";
export const PUT_LEGIS_SUMMARY_START = "PUT_LEGIS_SUMMARY_START";
export const PUT_LEGIS_SUMMARY_SUCCESS = "PUT_LEGIS_SUMMARY_SUCCESS";
export const PUT_LEGIS_SUMMARY_FAILURE = "PUT_LEGIS_SUMMARY_FAILURE";
export const PUT_CLIENT_ACTION_START = "PUT_CLIENT_ACTION_START";
export const PUT_CLIENT_ACTION_SUCCESS = "PUT_CLIENT_ACTION_SUCCESS";
export const PUT_CLIENT_ACTION_FAILURE = "PUT_CLIENT_ACTION_FAILURE";
export const PUT_CLIENT_ACTION_COMMENT_START =
  "PUT_CLIENT_ACTION_COMMENT_START";
export const PUT_CLIENT_ACTION_COMMENT_SUCCESS =
  "PUT_CLIENT_ACTION_COMMENT_SUCCESS";
export const PUT_CLIENT_ACTION_COMMENT_FAILURE =
  "PUT_CLIENT_ACTION_COMMENT_FAILURE";
export const GET_STATUS_REVIEW_BASE_START = "GET_STATUS_REVIEW_BASE_START";
export const GET_STATUS_REVIEW_BASE_SUCCESS = "GET_STATUS_REVIEW_BASE_SUCCESS";
export const GET_STATUS_REVIEW_BASE_FAILURE = "GET_STATUS_REVIEW_BASE_FAILURE";
export const GET_LEGIS_TRACK_KEYWORDS_START = "GET_LEGIS_TRACK_KEYWORDS_START";
export const GET_LEGIS_TRACK_KEYWORDS_SUCCESS =
  "GET_LEGIS_TRACK_KEYWORDS_SUCCESS";
export const GET_LEGIS_TRACK_KEYWORDS_FAILURE =
  "GET_LEGIS_TRACK_KEYWORDS_FAILURE";
export const GET_LEGIS_TRACK_CLIENT_SUBJECTS_START =
  "GET_LEGIS_TRACK_CLIENT_SUBJECTS_START";
export const GET_LEGIS_TRACK_CLIENT_SUBJECTS_SUCCESS =
  "GET_LEGIS_TRACK_CLIENT_SUBJECTS_SUCCESS";
export const GET_LEGIS_TRACK_CLIENT_SUBJECTS_FAILURE =
  "GET_LEGIS_TRACK_CLIENT_SUBJECTS_FAILURE";
export const GET_LEGIS_TRACK_LEGIS_TYPE_START =
  "GET_LEGIS_TRACK_LEGIS_TYPE_START";
export const GET_LEGIS_TRACK_LEGIS_TYPE_SUCCESS =
  "GET_LEGIS_TRACK_LEGIS_TYPE_SUCCESS";
export const GET_LEGIS_TRACK_LEGIS_TYPE_FAILURE =
  "GET_LEGIS_TRACK_LEGIS_TYPE_FAILURE";
export const GET_LEGIS_TRACK_LOAD_OPTIONS_START =
  "GET_LEGIS_TRACK_LOAD_OPTIONS_START";
export const GET_LEGIS_TRACK_LOAD_OPTIONS_FAILURE =
  "GET_LEGIS_TRACK_LOAD_OPTIONS_FAILURE";
export const CLEAR_STATUSREVIEW_FIELD_FOR_NO_RESULTS =
  "CLEAR_STATUSREVIEW_FIELD_FOR_NO_RESULTS";
export const RETURN_LEGIS_TRACK_INITIAL_STATE =
  "RETURN_LEGIS_TRACK_INITIAL_STATE";
export const OPEN_LEGIS_TRACK_RECORD_SUCCESS =
  "OPEN_LEGIS_TRACK_RECORD_SUCCESS";
export const SET_LEGIS_TRACK_ID_REVIEWED_START =
  "SET_LEGIS_TRACK_ID_REVIEWED_START";
export const SET_LEGIS_TRACK_ID_REVIEWED_FAILURE =
  "SET_LEGIS_TRACK_ID_REVIEWED_FAILURE";
export const SET_LEGIS_TRACK_ID_REVIEWED_SUCCESS =
  "SET_LEGIS_TRACK_ID_REVIEWED_SUCCESS";
export const GET_LEGIS_TRACK_HIGHLIGHTED_DOC_START =
  "GET_LEGIS_TRACK_HIGHLIGHTED_DOC_START";
export const GET_LEGIS_TRACK_HIGHLIGHTED_DOC_FAILURE =
  "GET_LEGIS_TRACK_HIGHLIGHTED_DOC_FAILURE";
export const GET_LEGIS_TRACK_HIGHLIGHTED_DOC_SUCCESS =
  "GET_LEGIS_TRACK_HIGHLIGHTED_DOC_SUCCESS";
export const GET_LEGIS_TRACK_INITIAL_DATA_START =
  "GET_LEGIS_TRACK_INITIAL_DATA_START";
export const GET_LEGIS_TRACK_INITIAL_DATA_COMPLETE =
  "GET_LEGIS_TRACK_INITIAL_DATA_COMPLETE";
export const GET_QC_KEYWORD_MISSING_START = "GET_QC_KEYWORD_MISSING_START";
export const GET_QC_KEYWORD_MISSING_SUCCESS = "GET_QC_KEYWORD_MISSING_SUCCESS";
export const GET_QC_KEYWORD_MISSING_FAILURE = "GET_QC_KEYWORD_MISSING_FAILURE";
export const GET_QC_KEYWORD_REVIEW_START = "GET_QC_KEYWORD_REVIEW_START";
export const GET_QC_KEYWORD_REVIEW_SUCCESS = "GET_QC_KEYWORD_REVIEW_SUCCESS";
export const GET_QC_KEYWORD_REVIEW_FAILURE = "GET_QC_KEYWORD_REVIEW_FAILURE";
export const GET_LEGIS_TRACK_SUBJECT_GROUP_LIST_START =
  "GET_LEGIS_TRACK_SUBJECT_GROUP_LIST_START";
export const GET_LEGIS_TRACK_SUBJECT_GROUP_LIST_FAILURE =
  "GET_LEGIS_TRACK_SUBJECT_GROUP_LIST_FAILURE";
export const GET_LEGIS_TRACK_SUBJECT_GROUP_LIST_SUCCESS =
  "GET_LEGIS_TRACK_SUBJECT_GROUP_LIST_SUCCESS";
export const SET_QC_KEYWORD_REVIEW_START = "SET_QC_KEYWORD_REVIEW_START";
export const SET_QC_KEYWORD_REVIEW_FAILURE = "SET_QC_KEYWORD_REVIEW_FAILURE";
export const SET_QC_KEYWORD_REVIEW_SUCCESS = "SET_QC_KEYWORD_REVIEW_SUCCESS";
export const DELETE_LEGIS_DOC_START = "DELETE_LEGIS_DOC_START";
export const DELETE_LEGIS_DOC_SUCCESS = "DELETE_LEGIS_DOC_SUCCESS";
export const DELETE_LEGIS_DOC_FAILURE = "DELETE_LEGIS_DOC_FAILURE";
export const ADD_LEGIS_DOC_START = "ADD_LEGIS_DOC_START";
export const ADD_LEGIS_DOC_SUCCESS = "ADD_LEGIS_DOC_SUCCESS";
export const ADD_LEGIS_DOC_FAILURE = "ADD_LEGIS_DOC_FAILURE";
export const DELETE_HEARING_START = "DELETE_HEARING_START";
export const DELETE_HEARING_SUCCESS = "DELETE_HEARING_SUCCESS";
export const DELETE_HEARING_FAILURE = "DELETE_HEARING_FAILURE";
export const ADD_HEARING_START = "ADD_HEARING_START";
export const ADD_HEARING_SUCCESS = "ADD_HEARING_SUCCESS";
export const ADD_HEARING_FAILURE = "ADD_HEARING_FAILURE";
export const GET_LEGIS_DOC_TYPES_START = "GET_LEGIS_DOC_TYPES_START";
export const GET_LEGIS_DOC_TYPES_FAILURE = "GET_LEGIS_DOC_TYPES_FAILURE";
export const GET_LEGIS_DOC_TYPES_SUCCESS = "GET_LEGIS_DOC_TYPES_SUCCESS";

export const DELETE_STATUS_CLIENT_SUBJECT_TAG_START =
  "DELETE_STATUS_CLIENT_SUBJECT_TAG_START";
export const DELETE_STATUS_CLIENT_SUBJECT_TAG_SUCCESS =
  "DELETE_STATUS_CLIENT_SUBJECT_TAG_SUCCESS";
export const DELETE_STATUS_CLIENT_SUBJECT_TAG_FAILURE =
  "DELETE_STATUS_CLIENT_SUBJECT_TAG_FAILURE";
export const PUT_STATUS_CLIENT_SUBJECT_TAG_START = "PUT_STATUS_CLIENT_SUBJECT_TAG_START";
export const PUT_STATUS_CLIENT_SUBJECT_TAG_SUCCESS = "PUT_STATUS_CLIENT_SUBJECT_TAG_SUCCESS";
export const PUT_STATUS_CLIENT_SUBJECT_TAG_FAILURE = "PUT_STATUS_CLIENT_SUBJECT_TAG_FAILURE";
export const UPDATE_SUBSCRIBE_DATE_ALL_START =
  "UPDATE_SUBSCRIBE_DATE_ALL_START";
export const UPDATE_SUBSCRIBE_DATE_ALL_SUCCESS =
  "UPDATE_SUBSCRIBE_DATE_ALL_SUCCESS";
export const UPDATE_SUBSCRIBE_DATE_ALL_FAILURE =
  "UPDATE_SUBSCRIBE_DATE_ALL_FAILURE";

// export const GET_STATUSREVIEW_HISTORY_START = "GET_STATUSREVIEW_HISTORY_START";
// export const GET_STATUSREVIEW_HISTORY_FAILURE = "GET_STATUSREVIEW_HISTORY_FAILURE";
// export const GET_STATUSREVIEW_HISTORY_SUCCESS = "GET_STATUSREVIEW_HISTORY_SUCCESS";

export const POST_STATUSREVIEW_UPDATE_START = "POST_STATUSREVIEW_UPDATE_START";
export const POST_STATUSREVIEW_UPDATE_SUCCESS = "POST_STATUSREVIEW_UPDATE_SUCCESS";
export const POST_STATUSREVIEW_UPDATE_FAILURE = "POST_STATUSREVIEW_UPDATE_FAILURE";

export const POST_HISTORYREVIEW_UPDATE_START = "POST_HISTORYREVIEW_UPDATE_START";
export const POST_HISTORYREVIEW_UPDATE_SUCCESS  = "POST_HISTORYREVIEW_UPDATE_SUCCESS ";
export const POST_HISTORYREVIEW_UPDATE_FAILURE = "POST_HISTORYREVIEW_UPDATE_FAILURE";

export const GET_STATUSREVIEW_HISTORY_LOG_START = "GET_STATUSREVIEW_HISTORY_LOG_START";
export const GET_STATUSREVIEW_HISTORY_LOG_SUCCESS = "GET_STATUSREVIEW_HISTORY_LOG_SUCCESS";
export const GET_STATUSREVIEW_HISTORY_LOG_FAILURE = "GET_STATUSREVIEW_HISTORY_LOG_FAILURE";

export const GET_STATUSREVIEW_SPR_RESULTS_START = "GET_STATUSREVIEW_SPR_RESULTS_START";
export const GET_STATUSREVIEW_SPR_RESULTS_SUCCESS = "GET_STATUSREVIEW_SPR_RESULTS_SUCCESS";
export const GET_STATUSREVIEW_SPR_RESULTS_FAILURE = "GET_STATUSREVIEW_SPR_RESULTS_FAILURE";

export const PUT_LEGIS_MANAGEMENT_COMMENT_START =
  "PUT_LEGIS_MANAGEMENT_COMMENT_START";
export const PUT_LEGIS_MANAGEMENT_COMMENT_SUCCESS =
  "PUT_LEGIS_MANAGEMENT_COMMENT_SUCCESS";
export const PUT_LEGIS_MANAGEMENT_COMMENT_FAILURE =
  "PUT_LEGIS_MANAGEMENT_COMMENT_FAILURE";

const headers = {
  "Content-Type": "application/json",
};

export function getStatusReviewInitialState() {
  return initialState;
}

export function getEasternDateFromString(date) {
  return date && date !== ""
    ? moment.tz(date, "YYYY-MM-DDTHH:mm:ss", "America/New_York")
    : null;
}

export function getEasternDateStringForAPI(date) {
  return date && date !== ""
    ? moment.tz(date, "YYYY-MM-DDTHH:mm:ss", "America/New_York")
    .format("YYYY-MM-DDTHH:mm:ss") : null;
}

function formatDateShort(date) {
  return date && date !== "" ? moment(date).format("MM/DD/YYYY") : "";
}

function matchReviewRows(rows) {
  return rows.map((item) => {
    return {
      textValues: {
        team: item.Team || "",
        assignedBy: item.AssignedBy || "",
        assignedDate: formatDate(item.AssignedDate),
        reviewedBy: item.ReviewedBy || "",
        reviewedDate: formatDate(item.ReviewedDate),
        type: item.FlagTypeDesc,
        flag: String(item.FlagType),
      },
      isReviewed: item.ReviewedBy !== null,
    };
  });
}

function matchRecordInfo(info) {
  const recordInfo = {
    raw: { ...info },
    textValues: {
      id: info.RawFileId || "",
      legisId: info.LegisId,
      introDate: formatDateShort(info.IntroDate),
      actionDate: getEasternDateFromString(info.ActionDate),
      loadDate: getEasternDateFromString(info.LoadDate),
      historyReviewed: info.HistoryReviewed,
      summary: info.Summary || "",
      rawSummary: info.RawSummary || "",
      rawSummaryDate: formatDate(info.RawSummaryChangedDate),

      // History Compare
      history: info.History || "",
      historyOld: info.HistoryOld || "",

      supplementalHistory: info.SupplementalHistory || "",
      historyRemarks: info.HistoryRemarks || "",
      historyRemarksUpdated: formatDate(info.RemarksUpdated),
      historyUpdated: formatDate(info.HistoryUpdated),

      effectiveModifiedDate: formatDate(info.EffectiveModifiedDate),
      effectiveDate: getEasternDateFromString(info.EffectiveDate),
      publicLawNumber: info.PublicActNo || "",

      // General
      year: info.Year || "",
      oldLoadDate: getEasternDateFromString(info.OldLoadDate),
      recordCreated: formatDate(info.CreateDate),
      lastUpdateToRecord: formatDate(info.LastUpdateTS),
      lastUpdateUserId: info.LastUpdateId || "",
      createUserId: info.CreateUserID || "",
      carryOver: info.CarryOver_Prefiled || "",
      country: info.CountryCode || "",
      state: info.State || "",
      billType: info.BillType || "",
      billNumber: info.BillNumber || "",
      session: info.Session || "",
      companion: info.Companion || "",
      url: info.Url || "",
      sspath: info.SSPath || "",
      versionUrl: info.RawFileId
        ? `https://services.statescape.com/search/billversions.aspx?rid=${info.RawFileId}`
        : "",
      rejectionCause: info.RejectionCause || "",
      ruleResults: [],
      serverTZOffset: info.TZOffset || -300.0,
    },
    radio: {
      summaryUpdating: info.SummaryUpdating || "",
      hideRawdata: !!info.HideRawdata,
      rawHistoryLast: !!info.RawHistoryLast,
    },
  };
  // Action flags handled in matchSubHistoryData (PassedHouse, PassedSenate, etc)
  return matchSubHistoryData(recordInfo, info);
}

function matchSubHistoryData(recordInfo, info) {
  return {
    ...recordInfo,
    textValues: {
      ...recordInfo.textValues,
      supplementalHistory: info.SupplementalHistory || "",
      historyRemarks: info.HistoryRemarks || "",
      historyRemarksUpdated: formatDate(info.RemarksUpdated),
      effectiveModifiedDate: formatDate(info.EffectiveModifiedDate),
      effectiveDate: getEasternDateFromString(info.EffectiveDate),
      publicLawNumber: info.PublicActNo || "",
    },
    currentLegisProgress: {
      boolValues: {
        // Action flags
        PassedHouseCommittee: info.PassedHouseCommittee,
        PassedSenateCommittee: info.PassedSenateCommittee,
        PassedHouse: info.PassedHouse,
        PassedSenate: info.PassedSenate,
        LegisAgreed: info.LegisAgreed,
        ApprovedEnacted: info.ApprovedEnacted,
        Vetoed: info.Vetoed,
        Active: info.Active,
        DiedKilled: info.DiedKilled,
      }
    }
  };
}

function matchDocuments(documents) {
  return documents
    ? documents.map((doc) => {
        return {
          url: doc.Url,
          description: doc.Description,
          urlType: doc.Type,
          id: doc.Id,
        };
      })
    : [];
}

function matchHearings(hearings) {
  return hearings
    ? hearings.map((hearing) => {
        return {
          id: hearing.Id,
          hearingDesc: hearing.HearingDesc,
          hearingDate: formatDate(hearing.HearingDate),
          url: hearing.Url,
          addedBy: hearing.AddedBy,
          auto: hearing.AutoManaged,
          urlType: "",
          warning: hearing.Warning,
          deletable: !hearing.AutoManaged,
        };
      })
    : [];
}

function matchClientSubjectTags(clientSubjectTags) {
  return clientSubjectTags
    ? clientSubjectTags.map((clientSubjectTag) => {
        return matchClientSubjectTag(clientSubjectTag);
      })
    : [];
}

function matchClientSubjectTag(clientSubjectTag) {
  return {
    SubjectId: clientSubjectTag.SubjectId,
    Client: clientSubjectTag.Client,
    Subject: clientSubjectTag.Subject,
    DataType: clientSubjectTag.DataType,
    RecordId: clientSubjectTag.RecordId,
    SubscribeDate: formatDate(clientSubjectTag.SubscribeDate),
    CreateUser: clientSubjectTag.CreateUser,
    OriginalCreateDate: formatDate(clientSubjectTag.OriginalCreateDate),
    LastUpdateDate: formatDate(clientSubjectTag.LastUpdateDate),
    LastUpdateUser: clientSubjectTag.LastUpdateUser,
    IssueId: clientSubjectTag.IssueId,
    EmailAlerts: clientSubjectTag.EmailAlerts,
    Deleted: clientSubjectTag.Deleted,
    Autoload: clientSubjectTag.Autoload,
    DeletedByAnalyst: clientSubjectTag.DeletedByAnalyst,
    CanEdit: clientSubjectTag.CanEdit,
  };
}

function matchLegisDocTypes(legisDocTypes) {
  return legisDocTypes
    ? legisDocTypes
        .filter((docType) => !docType.HideAnalystAdd)
        .map((docType) => {
          return {
            label: docType.DisplayName,
            value: docType.DocType,
          };
        })
    : [];
}

function matchNonDeletableDocTypes(legisDocTypes) {
  return legisDocTypes
    ? legisDocTypes.filter((docType) => docType.HideAnalystAdd)
    : [];
}

function matchClientActions(info) {
  return info.ClientActions
    ? info.ClientActions.map((action) => {
        return matchClientAction(action);
      })
    : [];
}

function matchClientAction(action) {
  return {
    textValues: {
      stsReviewer: action.StateScapeCheckedBy || "",
      reviewDate: formatDate(action.StateScapeCheckedDate),
      stsComment: action.StateScapeComments || "",
      client: action.Client || "",
      loginId: action.LogonId || "",
      action: action.Action || "",
      changedDate: formatDate(action.ChangeDate),
      userEmail: action.Email || "",
      actionDetails: action.ActionDetail || "",
      clientComment: action.ClientComments || "",
      clientActionId: action.ClientActionId || "",
    },
  };
}

function matchIderInfo(info) {
  return {
    textValues: {
      ider: info.IDer || "",
      iderReviewed: info.IDerReviewed || "",
      iderReviewedDate: formatDate(info.IDerReviewedDate),
    },
  };
}

function matchKeywordHits(hits) {
  return hits.map((hit) => {
    return {
      textValues: {
        team: hit.Team || "",
        client: hit.Client || "",
        grouping: hit.Subject || "",
        keyword: hit.Keyword || "",
        hits: hit.Hits,
        foundDate: formatDate(hit.FoundDate),
        changeDate: formatDate(hit.ChangeDate),
        oldHits: hit.OldHits,
        keywordId: hit.KeywordId,
        taggingInstructions: hit.GroupTaggingInstructions || "",
        description: hit.GroupDescription || "",
        overview: hit.GroupOverview || "",
        boolPhrase: hit.BoolPhrase,
        groupingId: hit.GroupingId,
      },
    };
  });
}

function matchClientSubjects(clients) {
  return clients.map((client) => {
    return {
      textValues: {
        deleted: client.DeleteIt || false,
        client: client.ClientName || "",
        clientDescription: client.ClientDescription || "",
        subject: client.Subject || "",
        subjectDescription: client.SubjectDescription || "",
        changeDate: formatDate(client.CreateDate),
        user: client.CreateUserId || "",
      },
    };
  });
}

function matchLegisHistory(history) {
  const actionFlags = [
    'PassedHouseCommittee',
    'PassedSenateCommittee',
    'PassedHouse',
    'PassedSenate',
    'LegisAgreed',
    'ApprovedEnacted',
    'Vetoed',
    'Active',
    'DiedKilled',
  ]
  let obj = {
    boolValues: history,
    selected: Object.keys(history).filter(
      (key) => history[key] && typeof history[key] == "boolean"
    ),
    initialSelected: Object.keys(history).filter(
      (key) => history[key] && typeof history[key] == "boolean"
    ),
    initialValues: {},
  };
  actionFlags.forEach(function(i){
    obj.initialValues[i] = history[i] == true;
  })
  return obj;
}

function matchQCKeywordReview(keywordsReview) {
  return keywordsReview.map((keywordReview) => {
    return {
      textValues: {
        reviewDate: formatDate(keywordReview.ReviewDate),
        reviewer: keywordReview.Reviewer || "",
        client: keywordReview.Client || "",
        subject: keywordReview.Subject || "",
      },
    };
  });
}

function matchQCKeywordMissing(keywordsMissing) {
  return keywordsMissing.map((keywordMissing) => {
    return {
      textValues: {
        client: keywordMissing.Client || "",
        subject: keywordMissing.Subject || "",
        team: keywordMissing.Team || "",
        id: keywordMissing.Id || "",
        reviewed: keywordMissing.Reviewed || "",
      },
    };
  });
}

function matchHistoryLog(historyLog) {
  return historyLog.map((log) => {
    return {
      HistoryDate: log.CreateDate,
      User: log.UserName,
      HistoryAction: log.Activity,
    };
  });
}

// ------------------------------------
// Actions
// ------------------------------------

const getReviewData = (legisId) => {
  return (dispatch) =>
    dispatch(getStatusReviewBase(legisId, dispatch)).then((recordInfo) => {
      const rawFileId = recordInfo.textValues.id;
      Promise.all([
        dispatch(getLegisKeywords(rawFileId)),
        dispatch(getLegisClientSubjects(rawFileId)),
        dispatch(getLegisHistoryLog(legisId)),
        dispatch(getLegisSPRResults(rawFileId)),
      ]);
    });
};

export function openReviewRecord(legisId) {
  return (dispatch) => {
    dispatch({ type: STATUS_REVIEW_OPEN_RECORD_START });
    dispatch(getReviewData(legisId, dispatch)).finally(() => {
      dispatch({
        type: OPEN_LEGIS_TRACK_RECORD_SUCCESS,
        payload: { legisId },
      });
    });
  };
}

const getInitialData = () => {
  return (dispatch) =>
    Promise.all([
      dispatch(getLegisTrackInternalQueryData()),
      dispatch(getLegisDocTypes()),
    ]);
};

export function loadInitialData() {
  return (dispatch) =>
    Promise.all([
      dispatch({ type: GET_LEGIS_TRACK_INITIAL_DATA_START }),
      dispatch(getInitialData()).finally(() => {
        dispatch({ type: GET_LEGIS_TRACK_INITIAL_DATA_COMPLETE });
      }),
    ]);
}

export function getLegisTrackInternalQueryData() {
  return (dispatch) => {
    dispatch({ type: GET_STATUS_REVIEW_QUERY_DATA_START });
    const options = {
      method: "GET",
      credentials: "include",
    };
    return fetch(`${globals.apiUrl}/statusreviewqueue`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({
                type: GET_STATUS_REVIEW_QUERY_DATA_FAILURE,
                json: text,
              });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: GET_STATUS_REVIEW_QUERY_DATA_SUCCESS,
            payload: {
              json,
            },
          });
        }
      })
      .catch((err) => {
        dispatch({
          type: GET_STATUS_REVIEW_QUERY_DATA_FAILURE,
          json: err.message,
        });
      });
  };
}

export function postStatusReviewQueue(legisUrlsParameters) {
  return (dispatch) => {
    dispatch({ type: POST_LEGIS_TRACK_DATA_START });
    const options = {
      method: "POST",
      credentials: "include",
      headers,
      body: JSON.stringify(legisUrlsParameters),
    };
    return fetch(`${globals.apiUrl}/statusreviewqueue`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({
                type: POST_LEGIS_TRACK_DATA_FAILURE,
                json: text,
              });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json && json.result) {
          dispatch({
            type: POST_LEGIS_TRACK_DATA_SUCCESS,
            payload: {
              json: json.result,
            },
          });
          if (json.result.length > 0) {
            dispatch(openReviewRecord(json.result[0]));
          } else {
            dispatch(showModal("No-results"));
            dispatch(clearFormFields());
          }
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: POST_LEGIS_TRACK_DATA_FAILURE,
          json: err.message,
        });
      });
  };
}

export function putLegisSummary(summaryData) {
  return (dispatch) => {
    dispatch({ type: PUT_LEGIS_SUMMARY_START });
    const options = {
      method: "Put",
      credentials: "include",
      headers,
      body: JSON.stringify(summaryData),
    };
    return fetch(`${globals.apiUrl}/legissummary`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({
                type: PUT_LEGIS_SUMMARY_FAILURE,
                json: text,
              });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: PUT_LEGIS_SUMMARY_SUCCESS,
            payload: {
              json,
            },
          });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: PUT_LEGIS_SUMMARY_FAILURE,
          json: err.message,
        });
      });
  };
}

export function putClientAction(clientActionId) {
  return (dispatch) => {
    dispatch({ type: PUT_CLIENT_ACTION_START });
    const options = {
      method: "Put",
      credentials: "include",
      headers,
      body: JSON.stringify({ ClientActionId: clientActionId }),
    };
    return fetch(`${globals.apiUrl}/clientaction`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({
                type: PUT_CLIENT_ACTION_FAILURE,
                json: text,
              });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: PUT_CLIENT_ACTION_SUCCESS,
            payload: {
              json,
            },
          });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: PUT_CLIENT_ACTION_FAILURE,
          json: err.message,
        });
      });
  };
}

export function putClientActionComment(clientAction) {
  return (dispatch) => {
    dispatch({ type: PUT_CLIENT_ACTION_COMMENT_START });
    const options = {
      method: "Put",
      credentials: "include",
      headers,
      body: JSON.stringify(clientAction),
    };
    return fetch(`${globals.apiUrl}/clientactioncomment`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({
                type: PUT_CLIENT_ACTION_COMMENT_FAILURE,
                json: text,
              });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: PUT_CLIENT_ACTION_COMMENT_SUCCESS,
            payload: {
              json,
            },
          });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: PUT_CLIENT_ACTION_COMMENT_FAILURE,
          json: err.message,
        });
      });
  };
}

export function postLegisTeamsReview(id, teams, reviewed, flagType) {
  return (dispatch) => {
    dispatch({ type: SET_LEGIS_TRACK_TEAMS_REVIEW_DATA_START });
    const options = {
      method: "POST",
      credentials: "include",
      headers,
      body: JSON.stringify({
        legisId: id,
        team: teams[0],
        reviewed: reviewed,
        flagType: flagType,
      }),
    };
    return fetch(`${globals.apiUrl}/RawFile/TeamReview`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({
                type: SET_LEGIS_TRACK_TEAMS_REVIEW_DATA_FAILURE,
                json: text,
              });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: SET_LEGIS_TRACK_TEAMS_REVIEW_DATA_SUCCESS,
            payload: {
              json,
              id,
            },
          });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: SET_LEGIS_TRACK_TEAMS_REVIEW_DATA_FAILURE,
          json: err.message,
        });
      });
  };
}

export function getStatusReviewBase(id) {
  return (dispatch) => {
    dispatch({ type: GET_STATUS_REVIEW_BASE_START });
    const options = {
      method: "GET",
      credentials: "include",
    };
    return fetch(`${globals.apiUrl}/statusreview/getdata/${id}`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({ type: GET_STATUS_REVIEW_BASE_FAILURE, json: text });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          const recordInfo = matchRecordInfo(json);
          const clientActions = matchClientActions(json);
          const documents = matchDocuments(json.Documents);
          const hearings = matchHearings(json.Hearings);
          const clientSubjectTags = matchClientSubjectTags(json.ClientSubjects);
          const currentLegisProgress = matchLegisHistory(recordInfo.currentLegisProgress.boolValues);
          dispatch({
            type: GET_STATUS_REVIEW_BASE_SUCCESS,
            payload: {
              recordInfo,
              clientActions,
              documents,
              clientSubjectTags,
              hearings,
              currentLegisProgress
            },
          });
          dispatch(clearHistory(pageIndex.statusReview));
          dispatch(
            saveInitialValues(pageIndex.statusReview, {
              recordInfo,
              clientActions,
              documents,
              currentLegisProgress,
              hearings,
            })
          );

          return recordInfo;
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: GET_STATUS_REVIEW_BASE_FAILURE, json: err.message });
      });
  };
}

export function postIdReviewed(id) {
  return (dispatch) => {
    dispatch({ type: SET_LEGIS_TRACK_ID_REVIEWED_START });
    const options = {
      method: "POST",
      credentials: "include",
      headers,
      body: id,
    };
    return fetch(`${globals.apiUrl}/RawFile/IdReview`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({
                type: SET_LEGIS_TRACK_ID_REVIEWED_FAILURE,
                json: text,
              });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: SET_LEGIS_TRACK_ID_REVIEWED_SUCCESS,
            payload: {
              json,
            },
          });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: SET_LEGIS_TRACK_ID_REVIEWED_FAILURE,
          json: err.message,
        });
      });
  };
}

export function getLegisKeywords(id) {
  return (dispatch) => {
    dispatch({ type: GET_LEGIS_TRACK_KEYWORDS_START });
    const options = {
      method: "GET",
      credentials: "include",
    };
    return fetch(`${globals.apiUrl}/RawFile/GetKeywords/${id}`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({ type: GET_LEGIS_TRACK_KEYWORDS_FAILURE, json: text });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: GET_LEGIS_TRACK_KEYWORDS_SUCCESS,
            payload: {
              json,
            },
          });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: GET_LEGIS_TRACK_KEYWORDS_FAILURE, json: err.message });
      });
  };
}

export function getLegisClientSubjects(id) {
  return (dispatch) => {
    dispatch({ type: GET_LEGIS_TRACK_CLIENT_SUBJECTS_START });
    const options = {
      method: "GET",
      credentials: "include",
    };
    return fetch(`${globals.apiUrl}/RawFile/GetClientSubjects/${id}`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({
                type: GET_LEGIS_TRACK_CLIENT_SUBJECTS_FAILURE,
                json: text,
              });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: GET_LEGIS_TRACK_CLIENT_SUBJECTS_SUCCESS,
            payload: {
              json,
            },
          });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: GET_LEGIS_TRACK_CLIENT_SUBJECTS_FAILURE,
          json: err.message,
        });
      });
  };
}

export function getQCKeywordReview(id) {
  return (dispatch) => {
    dispatch({ type: GET_QC_KEYWORD_REVIEW_START });
    const options = {
      method: "GET",
      credentials: "include",
    };
    return fetch(`${globals.apiUrl}/RawFile/GetQCKeywordReview/${id}`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({
                type: GET_QC_KEYWORD_REVIEW_FAILURE,
                json: text,
              });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: GET_QC_KEYWORD_REVIEW_SUCCESS,
            payload: {
              json,
            },
          });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: GET_QC_KEYWORD_REVIEW_FAILURE,
          json: err.message,
        });
      });
  };
}

export function getQCKeywordMissing(id) {
  return (dispatch) => {
    dispatch({ type: GET_QC_KEYWORD_MISSING_START });
    const options = {
      method: "GET",
      credentials: "include",
    };
    return fetch(`${globals.apiUrl}/RawFile/GetQCKeywordMissing/${id}`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({
                type: GET_QC_KEYWORD_MISSING_FAILURE,
                json: text,
              });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: GET_QC_KEYWORD_MISSING_SUCCESS,
            payload: {
              json,
            },
          });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: GET_QC_KEYWORD_MISSING_FAILURE,
          json: err.message,
        });
      });
  };
}

export function getSubjectGroupList(client, subject) {
  return (dispatch) => {
    dispatch({ type: GET_LEGIS_TRACK_SUBJECT_GROUP_LIST_START });

    const options = {
      method: "GET",
      credentials: "include",
    };

    const url = new URL(`${globals.apiUrl}/SubjectGroupList`);

    const params = {
      client,
      subject,
      searchType: "Legislation",
    };

    if (Object.keys(params)) {
      Object.keys(params).forEach((key) => {
        if (params[key]) {
          url.searchParams.append(key, params[key]);
        }
      });
    }

    return fetch(url, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({
                type: GET_LEGIS_TRACK_SUBJECT_GROUP_LIST_FAILURE,
                json: text,
              });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: GET_LEGIS_TRACK_SUBJECT_GROUP_LIST_SUCCESS,
            payload: {
              json,
            },
          });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: GET_LEGIS_TRACK_SUBJECT_GROUP_LIST_FAILURE,
          json: err.message,
        });
      });
  };
}

export function getHighlightedDocument(teams, keywords, path) {
  return (dispatch) => {
    dispatch({ type: GET_LEGIS_TRACK_HIGHLIGHTED_DOC_START });

    const options = {
      method: "GET",
      credentials: "include",
    };

    const url = new URL(`${globals.apiUrl}/KeywordHits`);

    const params = {
      docpath: path,
      service: "legis",
    };

    if (Object.keys(params)) {
      Object.keys(params).forEach((key) => {
        if (params[key]) {
          url.searchParams.append(key, params[key]);
        }
      });
    }

    if (teams && teams.length != 0) {
      teams.forEach((team) => {
        if (String(team).length > 0) {
          url.searchParams.append("teamId", team);
        }
      });
    }

    if (keywords && keywords.length != 0) {
      keywords.forEach((keyword) =>
        url.searchParams.append("keywordId", keyword)
      );
    }

    return fetch(url, options)
      .then((response) => {
        if (response.status === 200) {
          return response.url;
        } else if (response.status === 302) {
          return response.url;
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({
                type: GET_LEGIS_TRACK_HIGHLIGHTED_DOC_FAILURE,
                json: text,
              });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((url) => {
        if (url) {
          dispatch({
            type: GET_LEGIS_TRACK_HIGHLIGHTED_DOC_SUCCESS,
            payload: {
              url,
            },
          });
          return url;
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: GET_LEGIS_TRACK_HIGHLIGHTED_DOC_FAILURE,
          json: "Highlighting document: " + err.message,
        });
        dispatch(showModal("Error"));
      });
  };
}

export function postQCKeywordReview(rawfileId, team, customName) {
  return (dispatch) => {
    dispatch({ type: SET_QC_KEYWORD_REVIEW_START });

    const options = {
      method: "POST",
      credentials: "include",
      headers,
      body: JSON.stringify({ rawfileId, team, customName }),
    };

    return fetch(`${globals.apiUrl}/RawFile/QCKeywordReview`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({ type: SET_QC_KEYWORD_REVIEW_FAILURE, json: text });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((success) => {
        return success;
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: SET_QC_KEYWORD_REVIEW_FAILURE, json: err.message });
      });
  };
}

export function deleteLegisDocument(docId) {
  return (dispatch) => {
    dispatch({ type: DELETE_LEGIS_DOC_START });

    const options = {
      method: "DELETE",
      credentials: "include",
    };

    const url = new URL(`${globals.apiUrl}/legisdoc/${docId}`);

    return fetch(url, options)
      .then((response) => {
        if (response.status === 204 || response.status === 200) {
          dispatch({
            type: DELETE_LEGIS_DOC_SUCCESS,
            payload: {
              docId,
            },
          });
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (
          response.status === 400 ||
          response.status === 404 ||
          response.status === 409 ||
          response.status === 500
        ) {
          response.text().then((text) => {
            if (text) {
              dispatch({ type: DELETE_LEGIS_DOC_FAILURE, json: text });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: DELETE_LEGIS_DOC_FAILURE, json: err.message });
      });
  };
}

export function addLegisDocument(document) {
  return (dispatch) => {
    dispatch({ type: ADD_LEGIS_DOC_START });

    const { type, url, description, linkedRecord } = document;

    const options = {
      method: "POST",
      credentials: "include",
      headers,
      body: JSON.stringify({
        Type: type,
        Url: url,
        Description: description,
        RawFileId: linkedRecord,
      }),
    };

    return fetch(`${globals.apiUrl}/legisdoc`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400 || response.status === 409) {
          response.text().then((text) => {
            if (text) {
              dispatch({
                type: ADD_LEGIS_DOC_FAILURE,
                json: text,
              });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: ADD_LEGIS_DOC_SUCCESS,
            payload: {
              json,
            },
          });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: ADD_LEGIS_DOC_FAILURE,
          json: err.message,
        });
      });
  };
}

export function deleteHearing(hearingId) {
  return (dispatch) => {
    dispatch({ type: DELETE_HEARING_START });

    const options = {
      method: "DELETE",
      credentials: "include",
    };

    const url = new URL(`${globals.apiUrl}/hearing/${hearingId}`);

    return fetch(url, options)
      .then((response) => {
        if (response.status === 204 || response.status === 200) {
          dispatch({
            type: DELETE_HEARING_SUCCESS,
            payload: {
              hearingId,
            },
          });
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (
          response.status === 400 ||
          response.status === 404 ||
          response.status === 409 ||
          response.status === 500
        ) {
          response.text().then((text) => {
            if (text) {
              dispatch({ type: DELETE_HEARING_FAILURE, json: text });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: DELETE_HEARING_FAILURE, json: err.message });
      });
  };
}

export function addHearing(hearing) {
  return (dispatch) => {
    dispatch({ type: ADD_HEARING_START });

    const { url, hearingDesc, hearingDate, description, linkedRecord } = hearing;

    const options = {
      method: "POST",
      credentials: "include",
      headers,
      body: JSON.stringify({
        Url: url,
        hearingDate: hearingDate,
        hearingDesc: hearingDesc,
        desc: description,
        RawFileId: linkedRecord,
      }),
    };

    return fetch(`${globals.apiUrl}/hearing`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400 || response.status === 409) {
          response.text().then((text) => {
            if (text) {
              dispatch({
                type: ADD_HEARING_FAILURE,
                json: text,
              });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: ADD_HEARING_SUCCESS,
            payload: {
              json,
            },
          });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: ADD_HEARING_FAILURE,
          json: err.message,
        });
      });
  };
}

export function getLegisDocTypes() {
  return (dispatch) => {
    dispatch({ type: GET_LEGIS_DOC_TYPES_START });

    const options = {
      method: "GET",
      credentials: "include",
    };

    const url = new URL(`${globals.apiUrl}/rawfile/getLegisDocTypes`);

    return fetch(url, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({
                type: GET_LEGIS_DOC_TYPES_FAILURE,
                json: text,
              });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: GET_LEGIS_DOC_TYPES_SUCCESS,
            payload: {
              json,
            },
          });
          return json;
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: GET_LEGIS_DOC_TYPES_FAILURE,
          json: "Highlighting document: " + err.message,
        });
        dispatch(showModal("Error"));
      });
  };
}


export function getLegisSPRResults(legisId) {
  return (dispatch) => {
    dispatch({ type: GET_STATUSREVIEW_SPR_RESULTS_START });

    const options = {
      method: "GET",
      credentials: "include",
    };

    const url = new URL(`${globals.apiUrl}/StatusReview/getLegisRuleResults/${legisId}`);

    return fetch(url, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({
                type: GET_STATUSREVIEW_SPR_RESULTS_FAILURE,
                json: text,
              });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: GET_STATUSREVIEW_SPR_RESULTS_SUCCESS,
            payload: {
              json,
            },
          });
          return json;
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: GET_STATUSREVIEW_SPR_RESULTS_FAILURE,
          json: "SPR Results : " + err.message,
        });
        dispatch(showModal("Error"));
      });
  };
}


export function deleteClientSubjectTag(subjectId) {
  return (dispatch) => {
    dispatch({ type: DELETE_STATUS_CLIENT_SUBJECT_TAG_START });

    const options = {
      method: "DELETE",
      credentials: "include",
    };

    const url = new URL(`${globals.apiUrl}/clientSubjectTag/${subjectId}`);

    return fetch(url, options)
      .then((response) => {
        if (response.status === 204 || response.status === 200) {
          dispatch({
            type: DELETE_STATUS_CLIENT_SUBJECT_TAG_SUCCESS,
            payload: {
              subjectId,
            },
          });
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (
          response.status === 400 ||
          response.status === 404 ||
          response.status === 409 ||
          response.status === 500
        ) {
          response.text().then((text) => {
            if (text) {
              dispatch({ type: DELETE_STATUS_CLIENT_SUBJECT_TAG_FAILURE, json: text });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: DELETE_STATUS_CLIENT_SUBJECT_TAG_FAILURE,
          json: err.message,
        });
      });
  };
}

export function putClientSubjectTag(clientSubjectTag) {
  return (dispatch) => {
    dispatch({ type: PUT_STATUS_CLIENT_SUBJECT_TAG_START });
    const options = {
      method: "Put",
      credentials: "include",
      headers,
      body: [JSON.stringify(clientSubjectTag)],
    };
    return fetch(`${globals.apiUrl}/clientSubjectTag`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({
                type: PUT_STATUS_CLIENT_SUBJECT_TAG_FAILURE,
                json: text,
              });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: PUT_STATUS_CLIENT_SUBJECT_TAG_SUCCESS,
            payload: {
              json,
            },
          });
        }

        return json;
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: PUT_STATUS_CLIENT_SUBJECT_TAG_FAILURE,
          json: err.message,
        });
      });
  };
}

export function updateSubscribeDateForAll(recordId, dataType, subscribeDate) {
  return (dispatch) => {
    dispatch({ type: UPDATE_SUBSCRIBE_DATE_ALL_START });
    const options = {
      method: "Put",
      credentials: "include",
      headers,
      body: JSON.stringify({
        recordId,
        dataType,
        subscribeDate,
      }),
    };
    return fetch(`${globals.apiUrl}/ClientSubjectSubscription`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({
                type: UPDATE_SUBSCRIBE_DATE_ALL_FAILURE,
                json: text,
              });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: UPDATE_SUBSCRIBE_DATE_ALL_SUCCESS,
            payload: {
              json,
            },
          });
          return true;
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: UPDATE_SUBSCRIBE_DATE_ALL_FAILURE,
          json: err.message,
        });
      });
  };
}

// export function getLegistrackinthistory(legisId) {
//   return (dispatch) => {
//     dispatch({ type: GET_STATUSREVIEW_HISTORY_START });

//     const options = {
//       method: "GET",
//       credentials: "include",
//     };

//     const url = new URL(`${globals.apiUrl}/legistrackinthistory/${legisId}`);

//     return fetch(url, options)
//       .then((response) => {
//         if (response.status === 200) {
//           return response.json();
//         } else if (response.status === 401) {
//           dispatch(logOut());
//         } else if (response.status === 400) {
//           response.text().then((text) => {
//             if (text) {
//               dispatch({
//                 type: GET_STATUSREVIEW_HISTORY_FAILURE,
//                 json: text,
//               });
//               dispatch(showModal("Error"));
//             }
//           });
//         }
//       })
//       .then((json) => {
//         if (json) {
//           dispatch({
//             type: GET_STATUSREVIEW_HISTORY_SUCCESS,
//             payload: {
//               json,
//             },
//           });
//           return json;
//         }
//       })
//       .catch((err) => {
//         console.log(err);
//         dispatch({
//           type: GET_STATUSREVIEW_HISTORY_FAILURE,
//           json: "Highlighting document: " + err.message,
//         });
//         dispatch(showModal("Error"));
//       });
//   };
// }

export function updateStatusReview(statusReviewData) {
  return (dispatch) => {
    dispatch({ type: POST_STATUSREVIEW_UPDATE_START });

    const statusReviewDataConverted = { ...statusReviewData,
      loadDate: getEasternDateStringForAPI(statusReviewData.loadDate),
      actionDate: getEasternDateStringForAPI(statusReviewData.actionDate),
      effectiveDate: getEasternDateStringForAPI(statusReviewData.effectiveDate),
    };

    const options = {
      method: "Post",
      credentials: "include",
      headers,
      body: JSON.stringify(statusReviewDataConverted),
    };

    return fetch(`${globals.apiUrl}/StatusReview/Update`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400 || response.status === 409) {
          response.text().then((text) => {
            if (text) {
              dispatch({
                type: POST_STATUSREVIEW_UPDATE_FAILURE,
                json: text,
              });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          // dispatch({
          //   type: POST_STATUSREVIEW_UPDATE_SUCCESS,
          //   payload: {
          //     json,
          //   },
          // });

          const recordInfo = matchRecordInfo(json);
          //const clientActions = matchClientActions(json);
          //const documents = matchDocuments(json.Documents);
          //const hearings = matchHearings(json.Hearings);
          //const clientSubjectTags = matchClientSubjectTags(json.ClientSubjects);
          const currentLegisProgress = matchLegisHistory(recordInfo.currentLegisProgress.boolValues);

          dispatch({
            // type: GET_STATUS_REVIEW_BASE_SUCCESS,
            type: POST_STATUSREVIEW_UPDATE_SUCCESS,
            payload: {
              recordInfo,
              // clientActions,
              // documents,
              // clientSubjectTags,
              // hearings,
              currentLegisProgress,
              info: json,
            },
          });

          // REVIEW 09JAN2022

          // dispatch(clearHistory(pageIndex.statusReview));

          // dispatch(
          //   saveInitialValues(pageIndex.statusReview, {
          //     recordInfo,
          //     // clientActions,
          //     // documents,
          //     currentLegisProgress,
          //     // hearings,
          //   })
          // );

        }
        return json;
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: POST_STATUSREVIEW_UPDATE_FAILURE,
          json: err.message,
        });
      });
  };
}

export function postHistoryReview(reviewData) {
  return (dispatch) => {
    dispatch({ type: POST_STATUSREVIEW_UPDATE_START });
    const options = {
      method: "Post",
      credentials: "include",
      headers,
      body: JSON.stringify(reviewData),
    };

    return fetch(`${globals.apiUrl}/StatusReview/Review`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400 || response.status === 409) {
          response.text().then((text) => {
            if (text) {
              dispatch({
                type: POST_HISTORYREVIEW_UPDATE_FAILURE,
                json: text,
              });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: POST_HISTORYREVIEW_UPDATE_SUCCESS,
            payload: {
              json,
            },
          });
        }
        return json;
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: POST_HISTORYREVIEW_UPDATE_FAILURE,
          json: err.message,
        });
      });
  };
}

export function getLegisHistoryLog(id) {
  return (dispatch) => {
    dispatch({ type: GET_STATUSREVIEW_HISTORY_LOG_START });
    const options = {
      method: "GET",
      credentials: "include",
    };

    const url = new URL(`${globals.apiUrl}/HistoryLog`);

    const params = {
      entityType: 5,
      entityId: id,
    };

    if (Object.keys(params)) {
      Object.keys(params).forEach((key) => {
        if (params[key]) {
          url.searchParams.append(key, params[key]);
        }
      });
    }

    return fetch(url, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({ type: GET_STATUSREVIEW_HISTORY_LOG_FAILURE, json: text });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: GET_STATUSREVIEW_HISTORY_LOG_SUCCESS,
            payload: {
              json,
            },
          });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: GET_STATUSREVIEW_HISTORY_LOG_FAILURE, json: err.message });
      });
  };
}

export function clearFormFields() {
  return {
    type: CLEAR_STATUSREVIEW_FIELD_FOR_NO_RESULTS,
  };
}

export function returnInitialState() {
  return {
    type: RETURN_LEGIS_TRACK_INITIAL_STATE,
  };
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [UPDATE_DATA]: (state, action) =>
    action.location.page !== pageIndex.statusReview
      ? state
      : actionHandler(state, action),
  [RETURN_LEGIS_TRACK_INITIAL_STATE]: () => {
    return {
      ...initialState,
    };
  },
  [GET_STATUS_REVIEW_QUERY_DATA_START]: (state) => {
    return {
      ...state,
      isFetchingData: true,
    };
  },
  [GET_STATUS_REVIEW_QUERY_DATA_SUCCESS]: (state, action) => {
    const { json } = action.payload;
    return {
      ...state,
      renderData: {
        ...state.renderData,
        queriesWithParameters: json,
        queries: json.map((item) => {
          return {
            value: item.QueryId,
            label: item.QueryName,
          };
        }),
      },
    };
  },
  [PUT_LEGIS_SUMMARY_START]: (state) => {
    return {
      ...state,
      //isFetchingData: true,
    };
  },
  [PUT_LEGIS_SUMMARY_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isFetchingData: false,
      isError: true,
    };
  },
  [PUT_LEGIS_SUMMARY_SUCCESS]: (state, action) => {
    const info = action.payload.json;
    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        SR: {
          ...state.formDataValue.SR,
          recordInfo: {
            ...state.formDataValue.SR.recordInfo,
            textValues: {
              ...state.formDataValue.SR.recordInfo.textValues,
              summary: info.Summary || "",
              summaryUpdateDate: formatDate(info.SummaryUpdated),
            },
            radio: {
              ...state.formDataValue.SR.recordInfo.radio,
              summaryUpdating: info.SummaryView || "",
            },
          },
        },
      },
    };
  },
  [POST_STATUSREVIEW_UPDATE_START]: (state) => {
    return {
      ...state,
      //isFetchingData: true,
    };
  },
  [POST_STATUSREVIEW_UPDATE_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isFetchingData: false,
      isError: true,
    };
  },
  [POST_STATUSREVIEW_UPDATE_SUCCESS]: (state, action) => {

    // const info = action.payload.json;
    // const currentLegisProgress = matchLegisHistory(info);

    // const newState = {
    //   ...state,
    //   formDataValue: {
    //     ...state.formDataValue,
    //     SR: {
    //       ...state.formDataValue.SR,
    //       currentLegisProgress: currentLegisProgress,
    //       recordInfo: matchSubHistoryData(
    //         state.formDataValue.SR.recordInfo,
    //         info
    //       ),
    //     },
    //   },
    // };
    // return newState;

    const recordInfo = action.payload.recordInfo;
    const currentLegisProgress = action.payload.currentLegisProgress;
    const info = action.payload.info;

    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        SR: {
          ...state.formDataValue.SR,
          currentLegisProgress: currentLegisProgress,
          recordInfo: recordInfo,
        },
      },
    };

  },

  [POST_HISTORYREVIEW_UPDATE_START]: (state) => {
    return {
      ...state,
      //isFetchingData: true,
    };
  },
  [POST_HISTORYREVIEW_UPDATE_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isFetchingData: false,
      isError: true,
    };
  },
  [POST_HISTORYREVIEW_UPDATE_SUCCESS ]: (state) => {
    return {
      ...state,
      //isFetchingData: true,
    };
  },
  [UPDATE_SUBSCRIBE_DATE_ALL_START]: (state) => {
    return {
      ...state,
      //isFetchingData: true,
    };
  },
  [UPDATE_SUBSCRIBE_DATE_ALL_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isFetchingData: false,
      isError: true,
    };
  },
  [UPDATE_SUBSCRIBE_DATE_ALL_SUCCESS]: (state, action) => {
    const clientSubjectTags = matchClientSubjectTags(action.payload.json);

    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        SR: {
          ...state.formDataValue.SR,
          clientSubjectTags,
        },
      },
    };
  },
  [PUT_STATUS_CLIENT_SUBJECT_TAG_START]: (state) => {
    return {
      ...state,
      //isFetchingData: true,
    };
  },
  [PUT_STATUS_CLIENT_SUBJECT_TAG_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isFetchingData: false,
      isError: true,
    };
  },
  [PUT_STATUS_CLIENT_SUBJECT_TAG_SUCCESS]: (state, action) => {
    const newCientSubjectTag = action.payload.json;

    const tageIndex = state.formDataValue.SR.clientSubjectTags.findIndex(
      (clientSubjectTag) =>
        clientSubjectTag.SubjectId === newCientSubjectTag.SubjectId
    );

    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        SR: {
          ...state.formDataValue.SR,
          clientSubjectTags: Object.assign(
            [],
            state.formDataValue.SR.clientSubjectTags,
            {
              [tageIndex]: matchClientSubjectTag(newCientSubjectTag),
            }
          ),
        },
      },
    };
  },
  [PUT_CLIENT_ACTION_COMMENT_START]: (state) => {
    return {
      ...state,
      //isFetchingData: true,
    };
  },
  [PUT_CLIENT_ACTION_COMMENT_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isFetchingData: false,
      isError: true,
    };
  },
  [PUT_CLIENT_ACTION_COMMENT_SUCCESS]: (state, action) => {
    return clientActionSuccess(action, state);
  },
  [PUT_CLIENT_ACTION_START]: (state) => {
    return {
      ...state,
      //isFetchingData: true,
    };
  },
  [PUT_CLIENT_ACTION_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isFetchingData: false,
      isError: true,
    };
  },
  [PUT_CLIENT_ACTION_SUCCESS]: (state, action) => {
    return clientActionSuccess(action, state);
  },
  [POST_LEGIS_TRACK_DATA_START]: (state) => {
    return {
      ...state,
      isFetchingData: true,
    };
  },
  [POST_LEGIS_TRACK_DATA_SUCCESS]: (state, action) => {
    const queryRecords = action.payload.json;
    return {
      ...state,
      renderData: {
        ...state.renderData,
        queryRecords,
      },
    };
  },
  [POST_LEGIS_TRACK_DATA_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isFetchingData: false,
      isError: true,
    };
  },
  [SET_LEGIS_TRACK_TEAMS_REVIEW_DATA_START]: (state) => {
    return {
      ...state,
    };
  },
  [SET_LEGIS_TRACK_TEAMS_REVIEW_DATA_SUCCESS]: (state, action) => {
    const recordsData = action.payload.json;
    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        SR: {
          ...state.formDataValue.SR,
          reviewRecords: matchReviewRows(recordsData),
        },
      },
    };
  },
  [SET_LEGIS_TRACK_TEAMS_REVIEW_DATA_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isError: true,
    };
  },
  [DELETE_LEGIS_DOC_START]: (state) => {
    return {
      ...state,
    };
  },
  [DELETE_LEGIS_DOC_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isError: true,
    };
  },
  [DELETE_LEGIS_DOC_SUCCESS]: (state, action) => {
    const { docId } = action.payload;
    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        SR: {
          ...state.formDataValue.SR,
          documents: state.formDataValue.SR.documents.filter(
            (doc) => doc.id !== docId
          ),
        },
      },
    };
  },
  [DELETE_STATUS_CLIENT_SUBJECT_TAG_START]: (state) => {
    return {
      ...state,
    };
  },
  [DELETE_STATUS_CLIENT_SUBJECT_TAG_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isError: true,
    };
  },
  [DELETE_STATUS_CLIENT_SUBJECT_TAG_SUCCESS]: (state, action) => {
    const { subjectId } = action.payload;
    const newClientSubjectTags = [...state.formDataValue.SR.clientSubjectTags];
    const changingClientSubjectTag = newClientSubjectTags.find(
      (clientSubjectTag) => clientSubjectTag.SubjectId === subjectId
    );

    changingClientSubjectTag.Deleted = true;

    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        SR: {
          ...state.formDataValue.SR,
          clientSubjectTags: newClientSubjectTags,
        },
      },
    };
  },
  [ADD_LEGIS_DOC_START]: (state) => {
    return {
      ...state,
    };
  },
  [ADD_LEGIS_DOC_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isError: true,
    };
  },
  [ADD_LEGIS_DOC_SUCCESS]: (state, action) => {
    const { json } = action.payload;
    const newDocument = matchDocuments([json]);
    const newDocuments = [...state.formDataValue.SR.documents, ...newDocument];
    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        SR: {
          ...state.formDataValue.SR,
          documents: newDocuments,
        },
      },
    };
  },
  [DELETE_HEARING_START]: (state) => {
    return {
      ...state,
    };
  },
  [DELETE_HEARING_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isError: true,
    };
  },
  [DELETE_HEARING_SUCCESS]: (state, action) => {
    const { docId } = action.payload;
    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        SR: {
          ...state.formDataValue.SR,
          hearings: state.formDataValue.SR.hearings.filter(
            (doc) => doc.id !== docId
          ),
        },
      },
    };
  },
  [ADD_HEARING_START]: (state) => {
    return {
      ...state,
    };
  },
  [ADD_HEARING_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isError: true,
    };
  },
  [ADD_HEARING_SUCCESS]: (state, action) => {
    const { json } = action.payload;
    const newHearing = matchHearings([json]);
    const newHearings = [...state.formDataValue.SR.hearings, ...newHearing];
    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        SR: {
          ...state.formDataValue.SR,
          hearings: newHearings,
        },
      },
    };
  },
  [GET_STATUS_REVIEW_QUERIES_LIST_START]: (state) => {
    return {
      ...state,
      isFetchingData: true,
    };
  },
  [GET_STATUS_REVIEW_BASE_START]: (state) => {
    return {
      ...state,
    };
  },
  [GET_STATUS_REVIEW_BASE_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isError: true,
    };
  },
  [GET_STATUS_REVIEW_BASE_SUCCESS]: (state, action) => {
    const clientActions = action.payload.clientActions;
    const recordInfo = action.payload.recordInfo;
    const documents = action.payload.documents;
    const clientSubjectTags = action.payload.clientSubjectTags;
    const hearings = action.payload.hearings;
    const currentLegisProgress = action.payload.currentLegisProgress;

    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        SR: {
          ...state.formDataValue.SR,
          recordInfo,
          clientActions,
          documents,
          clientSubjectTags,
          hearings,
          currentLegisProgress,
        },
      },
    };
  },
  [GET_LEGIS_TRACK_INITIAL_DATA_START]: (state) => {
    return {
      ...state,
      isFetchingData: true,
    };
  },
  [GET_LEGIS_TRACK_INITIAL_DATA_COMPLETE]: (state) => {
    return {
      ...state,
      isFetchingData: false,
    };
  },
  [STATUS_REVIEW_OPEN_RECORD_START]: (state) => {
    return {
      ...state,
      isFetchingData: true,
    };
  },
  [OPEN_LEGIS_TRACK_RECORD_SUCCESS]: (state, action) => {
    const currentIndex = state.renderData.queryRecords.findIndex(
      (record) => record === action.payload.legisId
    );
    return {
      ...state,
      isFetchingData: false,
      formDataValue: {
        ...state.formDataValue,
        SR: {
          ...state.formDataValue.SR,
          currentLegisId: action.payload.legisId,
          navigation: {
            ...state.formDataValue.SR.navigation,
            textValues: {
              ...state.formDataValue.SR.navigation.textValues,
              currentRecord: currentIndex + 1,
            },
          },
        },
      },
    };
  },
  [SET_LEGIS_TRACK_ID_REVIEWED_SUCCESS]: (state, action) => {
    const iderInfo = action.payload.json;
    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        SR: {
          ...state.formDataValue.SR,
          iderReviewedInfo: matchIderInfo(iderInfo),
        },
      },
    };
  },
  [GET_LEGIS_TRACK_KEYWORDS_SUCCESS]: (state, action) => {
    const keywordHits = action.payload.json;
    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        SR: {
          ...state.formDataValue.SR,
          recordKeywordHits: matchKeywordHits(keywordHits),
        },
      },
    };
  },
  [GET_LEGIS_TRACK_CLIENT_SUBJECTS_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isError: true,
    };
  },
  [GET_LEGIS_TRACK_CLIENT_SUBJECTS_SUCCESS]: (state, action) => {
    const keywordHits = action.payload.json;
    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        SR: {
          ...state.formDataValue.SR,
          recordClientSubjects: matchClientSubjects(keywordHits),
        },
      },
    };
  },
  [GET_STATUSREVIEW_HISTORY_LOG_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isError: true,
    };
  },
  [GET_STATUSREVIEW_HISTORY_LOG_SUCCESS]: (state, action) => {
    const historyLog = action.payload.json;
    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        SR: {
          ...state.formDataValue.SR,
          textBlocks: {
            ...state.formDataValue.SR.textBlocks,
            textValues: {
              ...state.formDataValue.SR.textBlocks.textValues,
              log: matchHistoryLog(historyLog),
            },
          },
        },
      },
    };
  },
  [GET_STATUSREVIEW_SPR_RESULTS_SUCCESS]: (state, action) => {
    const sprResults = action.payload.json;
    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        SR: {
          ...state.formDataValue.SR,
          textBlocks: {
            ...state.formDataValue.SR.textBlocks,
            textValues: {
              ...state.formDataValue.SR.textBlocks.textValues,
              ruleResults: sprResults,
            },
          },
        },
      },
    };
  },
  [GET_QC_KEYWORD_MISSING_SUCCESS]: (state, action) => {
    const keywordsMissing = action.payload.json;
    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        SR: {
          ...state.formDataValue.SR,
          recordQCKeywordMissing: matchQCKeywordMissing(keywordsMissing),
        },
      },
    };
  },
  [GET_QC_KEYWORD_REVIEW_SUCCESS]: (state, action) => {
    const keywordsReview = action.payload.json;
    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        SR: {
          ...state.formDataValue.SR,
          recordQCKeywordReview: matchQCKeywordReview(keywordsReview),
        },
      },
    };
  },
  [GET_LEGIS_TRACK_HIGHLIGHTED_DOC_START]: (state) => {
    return {
      ...state,
    };
  },
  [GET_LEGIS_TRACK_HIGHLIGHTED_DOC_SUCCESS]: (state) => {
    return {
      ...state,
    };
  },
  [GET_LEGIS_TRACK_HIGHLIGHTED_DOC_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isError: true,
    };
  },
  [GET_LEGIS_DOC_TYPES_START]: (state) => {
    return {
      ...state,
      isFetchingData: true,
    };
  },
  [GET_LEGIS_DOC_TYPES_SUCCESS]: (state, action) => {
    const legisDocTypes = matchLegisDocTypes(action.payload.json);
    const nonDeletableDocTypes = matchNonDeletableDocTypes(action.payload.json);
    return {
      ...state,
      renderData: {
        ...state.renderData,
        legisDocTypes: legisDocTypes,
        nonDeletableDocTypes: nonDeletableDocTypes,
      },
    };
  },
  [GET_LEGIS_DOC_TYPES_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isFetchingData: false,
      isError: true,
    };
  },
  // [GET_STATUSREVIEW_HISTORY_START]: (state) => {
  //   return {
  //     ...state,
  //     isFetchingData: true,
  //   };
  // },
  // [GET_STATUSREVIEW_HISTORY_SUCCESS]: (state, action) => {
  //   const currentLegisProgress = matchLegisHistory(action.payload.json);
  //   return {
  //     ...state,
  //     formDataValue: {
  //       ...state.formDataValue,
  //       SR: {
  //         ...state.formDataValue.SR,
  //         currentLegisProgress: currentLegisProgress,
  //       },
  //     },
  //   };
  // },
  // [GET_STATUSREVIEW_HISTORY_FAILURE]: (state, action) => {
  //   return {
  //     ...state,
  //     errorCode: action.json,
  //     isFetchingData: false,
  //     isError: true,
  //   };
  // },
  [POST_CLIENT_SUBJECT_TAG_SUCCESS]: (state, action) => {
    const clientSubjectTags = matchClientSubjectTags(action.payload.json);

    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        SR: {
          ...state.formDataValue.SR,
          clientSubjectTags: [
            ...clientSubjectTags,
            ...state.formDataValue.SR.clientSubjectTags,
          ],
        },
      },
    };
  },
  [POST_CLIENT_SUBJECT_TAG_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isFetchingData: false,
    };
  },
  [GET_LEGIS_TRACK_SUBJECT_GROUP_LIST_START]: (state, action) => {
    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        SR: {
          ...state.formDataValue.SR,
          clientSubjectGroupings: [],
        },
      },
    };
  },
  [GET_LEGIS_TRACK_SUBJECT_GROUP_LIST_SUCCESS]: (state, action) => {
    const groupingsList = action.payload.json;
    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        SR: {
          ...state.formDataValue.SR,
          clientSubjectGroupings: groupingsList,
        },
      },
    };
  },
  [GET_LEGIS_TRACK_SUBJECT_GROUP_LIST_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isFetchingData: false,
      isError: true,
    };
  },
  [SET_QC_KEYWORD_REVIEW_START]: (state) => {
    return {
      ...state,
    };
  },
  [SET_QC_KEYWORD_REVIEW_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isFetchingData: false,
      isError: true,
    };
  },
  [GET_CLIENTS_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isFetchingData: false,
    };
  },
  [GET_CLIENT_SUBJECT_INFO_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isFetchingData: false,
    };
  },
  [GET_GROUPING_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isFetchingData: false,
    };
  },
  [GET_SUBJECTS_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isFetchingData: false,
    };
  },
  [CLEAR_STATUSREVIEW_FIELD_FOR_NO_RESULTS]: (state) => {

    const query = state.renderData.queriesWithParameters.find(
      (query) => query.QueryId == state.formDataValue.SR.queryLine.radio.query
    );

    const {
      parametersSectionSelectables,
      sortParameters,
      sortFields,
      sortDirections,
      filterFields,
    } = populateSortAndSearchParams(query);

    return {
      ...initialState,
      disableEditing: true,
      renderData: {
        ...initialState.renderData,
        queriesWithParameters: state.renderData.queriesWithParameters,
        queries: state.renderData.queries,
        allRegions: state.renderData.allRegions,
        regions: state.renderData.regions,
        regionsList: state.renderData.regionsList,
        legisDocTypes: state.renderData.legisDocTypes,
        nonDeletableDocTypes: state.renderData.nonDeletableDocTypes,
      },
      formDataValue: {
        SR: {
          ...initialState.formDataValue.SR,
          queryLine: {
            ...state.formDataValue.SR.queryLine,
          },
          parametersSection: {
            ...state.formDataValue.SR.parametersSection,
            radio: parametersSectionSelectables,
          },

          sortParameters: {
            radio: sortParameters,
            fields: sortFields,
          },
          sortDirections: {
            radio: sortDirections,
          },
          filterParameters: {
            fields: filterFields,
          }

        },
      },
    };
  },
};
// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {
  errorCode: "",
  isFetchingData: false,
  renderData: {
    queryRecords: [],
    queryProperties: [],
    currentRecord: {},
    recordIndex: 0,
  },
  formDataValue: {
    SR: {
      settingsLine: {
        radio: {
          autoAdvance: true,
          autoUrl: true,
          extraInfoExpanded: false,
          hearingInfoExpanded: false,
          clientActionsExpanded: false,
        },
      },
      queryLine: {
        radio: {
          query: "Select Query",
        },
        textValues: {
          keywordSearch: "",
        },
        selected: [],
      },
      parametersSection: {
        textValues: {},
        dateTime: {},
        radio: [],
      },
      sortParameters: {
        radio: [],
        fields: [],
      },
      sortDirections: {
        radio: [],
      },
      filterParameters: {
        fields: [],
      },
      navigation: {
        textValues: {
          currentRecord: "1",
        },
      },
      currentLegisProgress: matchLegisHistory([]),
      reviewRecords: matchReviewRows([]),
      recordInfo: matchRecordInfo({}),
      iderReviewedInfo: matchIderInfo({}),
      recordKeywordHits: matchKeywordHits([]),
      recordClientSubjects: matchClientSubjects([]),
      recordQCKeywordMissing: matchQCKeywordMissing([]),
      recordQCKeywordReview: matchQCKeywordReview([]),
      documents: matchDocuments([]),
      hearings: matchHearings([]),
      clientActions: matchClientActions([]),
      clientSubjectTags: [],
      clientSubjectGroupings: [],
      managementComments: [],
      otherDocs: {
        0: {
          textValues: {
            urlIdDocs: "",
            urlDescription: "",
          },
          radio: {
            docsType: "versions",
          },
        },
      },
      clients: {
        selected: [],
      },
      notLoadedClients: {
        selected: [],
      },
      history: {
        textValues: {
          history: "",
        },
      },
      textBlocks: {
        textValues: {
          log: [],
        },
      },
    },
  },
};

function clientActionSuccess(action, state) {
  const updatedClientAction = action.payload.json;
  const clientActionIndex = state.formDataValue.SR.clientActions.findIndex(
    (clientAction) =>
      clientAction.textValues.clientActionId ===
      updatedClientAction.ClientActionId
  );

  return {
    ...state,
    formDataValue: {
      ...state.formDataValue,
      SR: {
        ...state.formDataValue.SR,
        clientActions: Object.values({
          ...state.formDataValue.SR.clientActions,
          [clientActionIndex]: matchClientAction(updatedClientAction),
        }),
      },
    },
  };
}

export default function statusReviewReducer(
  state = initialState,
  action
) {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}



// WEBPACK FOOTER //
// ./src/store/reducers/statusReviewFormData.js